<template>
  <div
    class="w-6 h-6 border-4 border-iq-white/40 rounded-full animate-[spin_1s_linear_infinite] border-t-iq-white"
  />
</template>
